import { render, staticRenderFns } from "./EditDelegator.vue?vue&type=template&id=5362acd5"
import script from "./EditDelegator.vue?vue&type=script&lang=js"
export * from "./EditDelegator.vue?vue&type=script&lang=js"
import style0 from "./EditDelegator.vue?vue&type=style&index=0&id=5362acd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports